import axios from './http'

// 新增新书
export const PostAddBook = params => {
    return axios.post("/book", params).then(res => res.data)
};
// 修改新书
export const PutEditBook = params => {
    return axios.put("/book", params).then(res => res.data)
};
// 删除新书
export const DelBook = bookId => {
    return axios.delete(`/book/${bookId}`).then(res => res.data)
};
// 发布新书
export const PostPubBook = bookId => {
    return axios.put(`/book/publish/${bookId}`).then(res => res.data)
};
// 下架新书
export const PostOutBook = bookId => {
    return axios.put(`/book/soldout/${bookId}`).then(res => res.data)
};

// 查询新书列表
export const GetBookList = query => {
    return axios.get("/book/list", {params: query}).then(res => res.data)
};

// 查询单个新书
export const GetBookDetail = bookId => {
    return axios.get(`/book/${bookId}`).then(res => res.data)
};
// 删除新书单个图片
export const DelBookImg = picId => {
    return axios.delete(`/book/pic/${picId}`).then(res => res.data)
};